import { UserTypes } from '../../util/constants'

export const processPlans = (plans, _filter) => {
    let filter = _filter === UserTypes.Personal ? 'Individual' : _filter
    const filteredPlans = (!!filter
        ? plans.filter(e => e.type.toLowerCase() === filter.toLowerCase())
        : plans
    ).filter(e => e.status.toLowerCase() === 'active')

    const processedPlans = filteredPlans.map(plan => {
        //In case there's a new line because of parsing
        const parse = JSON.parse(`${plan.description.replace('\n', '.')}`)
        plan.description = parse.description
        plan.features = parse.features
        return plan
    })
    return processedPlans
}
